import Navbar from "../../../NavBar/NavBar.js";
import Footer from "../../../Home/Footer.js";
import Whatsapp from "../../../Home/Whatsapp.js";
import Spinner from "../../../Home/Spinner.js";
import { useEffect } from "react";
import SectionUs4 from "./page_us/solution-US-4/SectionUs4.js";

const US_ACOUSTIC_CABINE = () => {

  useEffect(() => {
  // ========= HELPERS =========
  const setMeta = (name, content) => {
    let tag = document.querySelector(`meta[name='${name}']`);
    if (!tag) {
      tag = document.createElement("meta");
      tag.setAttribute("name", name);
      document.head.appendChild(tag);
    }
    tag.setAttribute("content", content);
  };

  const setMetaProperty = (property, content) => {
    let tag = document.querySelector(`meta[property='${property}']`);
    if (!tag) {
      tag = document.createElement("meta");
      tag.setAttribute("property", property);
      document.head.appendChild(tag);
    }
    tag.setAttribute("content", content);
  };

  // ========= TITLE =========
  document.title =
    "Cabine Acoustique Maroc | Bureau & Open Space – UNIK SYSTEM";

  // ========= BASIC SEO =========
  setMeta(
    "description",
    "Cabines acoustiques au Maroc avec UNIK SYSTEM : solution idéale pour bureaux et open space. Isolation phonique, confidentialité et confort sonore pour espaces professionnels."
  );

  setMeta(
    "keywords",
    "cabine acoustique maroc, cabine phonique bureau maroc, cabine insonorisee maroc, isolation sonore bureau maroc, cabine silence open space maroc, cabine acoustique entreprise maroc, UNIK SYSTEM acoustic"
  );

  setMeta("robots", "index, follow");
  setMeta("author", "UNIK SYSTEM");

  // ========= CANONICAL =========
  let canonical = document.querySelector("link[rel='canonical']");
  if (!canonical) {
    canonical = document.createElement("link");
    canonical.setAttribute("rel", "canonical");
    document.head.appendChild(canonical);
  }
  canonical.setAttribute(
    "href",
    "https://unik-system.com/cabine-acoustique-maroc"
  );

  // ========= OPEN GRAPH =========
  setMetaProperty(
    "og:title",
    "Cabine Acoustique Maroc – Bureau & Silence | UNIK SYSTEM"
  );
  setMetaProperty(
    "og:description",
    "Cabines acoustiques professionnelles pour open space : silence, confort et productivité."
  );
  setMetaProperty(
    "og:image",
    "https://unik-system.com/static/media/27Cabine%20acoustique%20design%20pour%20bureau%20open%20space%20%E2%80%93%20isolation%20phonique%20et%20confort%20acoustique.43cc9a7487e53809d161.webp"
  );
  setMetaProperty(
    "og:url",
    "https://unik-system.com/cabine-acoustique-maroc"
  );
  setMetaProperty("og:type", "website");
  setMetaProperty("og:locale", "fr_FR");

  // ========= TWITTER =========
  setMeta("twitter:card", "summary_large_image");
  setMeta(
    "twitter:title",
    "Cabine Acoustique Maroc – UNIK SYSTEM"
  );
  setMeta(
    "twitter:description",
    "Solution idéale pour bureaux et open space avec isolation sonore."
  );
  setMeta(
    "twitter:image",
    "https://unik-system.com/static/media/27Cabine%20acoustique%20design%20pour%20bureau%20open%20space%20%E2%80%93%20isolation%20phonique%20et%20confort%20acoustique.43cc9a7487e53809d161.webp"
  );

  // ========= SCHEMA (LOCAL BUSINESS + SERVICE) =========
  const schema = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    name: "UNIK SYSTEM",
    url: "https://unik-system.com",
    description:
      "Spécialiste en cabines acoustiques professionnelles et isolation phonique au Maroc.",
    address: {
      "@type": "PostalAddress",
      addressCountry: "MA",
    },
    hasOfferCatalog: {
      "@type": "OfferCatalog",
      name: "Solutions Acoustiques",
      itemListElement: [
        {
          "@type": "Offer",
          itemOffered: {
            "@type": "Service",
            name: "Cabine Acoustique Bureau"
          }
        },
        {
          "@type": "Offer",
          itemOffered: {
            "@type": "Service",
            name: "Cabine Silence Open Space"
          }
        }
      ]
    }
  };

  let script = document.querySelector("#schema-us-acoustic");
  if (!script) {
    script = document.createElement("script");
    script.type = "application/ld+json";
    script.id = "schema-us-acoustic";
    document.head.appendChild(script);
  }
  script.innerHTML = JSON.stringify(schema);

  // ========= FAQ SCHEMA =========
  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: [
      {
        "@type": "Question",
        name: "Pourquoi utiliser une cabine acoustique ?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Elle réduit le bruit et améliore la concentration dans les espaces ouverts."
        }
      },
      {
        "@type": "Question",
        name: "Pour quels espaces ?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Bureaux, open space, call centers et espaces professionnels."
        }
      },
      {
        "@type": "Question",
        name: "Quels sont les avantages ?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Confidentialité, confort sonore, productivité et design moderne."
        }
      }
    ]
  };

  let faqScript = document.querySelector("#faq-schema-us-acoustic");
  if (!faqScript) {
    faqScript = document.createElement("script");
    faqScript.type = "application/ld+json";
    faqScript.id = "faq-schema-us-acoustic";
    document.head.appendChild(faqScript);
  }
  faqScript.innerHTML = JSON.stringify(faqSchema);

}, []);

  return (
    <div className="body">
      <Spinner />
      <Navbar />
      <Whatsapp />
      <SectionUs4 />
      <Footer />
    </div>
  );
};

export default US_ACOUSTIC_CABINE;
